import { render, staticRenderFns } from "./GlobalSalesTable.vue?vue&type=template&id=bb5cc63c"
import script from "./GlobalSalesTable.vue?vue&type=script&lang=js"
export * from "./GlobalSalesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports